import React, { useState } from 'react';
import { ChevronDownIcon } from 'lucide-react';
const faqs = [{
  q: 'È un prodotto fisico o digitale?',
  a: 'SENIOR FITNESS COACH PRO™ è un prodotto digitale in formato PDF ad alta qualità. Potrai scaricarlo immediatamente dopo l\'acquisto e utilizzarlo da computer, tablet o smartphone.'
}, {
  q: 'È adatto anche ai nuovi allenatori?',
  a: 'Sì. Il sistema è stato progettato sia per professionisti alle prime esperienze sia per allenatori esperti che desiderano risparmiare tempo e lavorare con maggiore organizzazione.'
}, {
  q: 'Posso adattare gli allenamenti ai miei clienti?',
  a: 'Assolutamente sì. Tutte le sessioni, i programmi, gli esercizi e i documenti possono essere personalizzati in base al livello, agli obiettivi e alle capacità funzionali di ogni cliente senior.'
}, {
  q: 'Dopo quanto tempo inizierò a risparmiare tempo?',
  a: 'La maggior parte degli allenatori inizia già dalla prima settimana a preparare le lezioni molto più velocemente e a lavorare con maggiore organizzazione.'
}, {
  q: 'Funziona per lezioni di gruppo e individuali?',
  a: 'Sì. Le sessioni, i circuiti e i programmi includono varianti per allenamenti individuali, piccoli gruppi e classi numerose, con adattamenti immediati per gruppi di livelli differenti.'
}, {
  q: 'Serve attrezzatura particolare?',
  a: 'No. Gli esercizi sono organizzati anche per attrezzatura disponibile: puoi lavorare a corpo libero, con sedia, elastici, pesi leggeri, palle o step, secondo ciò che hai in sala.'
}, {
  q: 'Posso stampare le schede e i planner?',
  a: 'Sì. Sessioni, schede di valutazione, registri, checklist e planner sono progettati per essere stampati e usati direttamente in palestra, in studio o in aula.'
}, {
  q: 'È un pagamento unico o un abbonamento?',
  a: 'È un pagamento unico di 27€. Nessun costo ricorrente: accedi a tutti i 6 moduli e ai 5 bonus per sempre.'
}, {
  q: 'Riceverò subito anche i 5 bonus?',
  a: 'Sì. Tutti i 5 bonus esclusivi sono inclusi nello stesso accesso immediato che ricevi via email dopo l\'acquisto, senza attese e senza passaggi extra.'
}, {
  q: 'Come funziona il rimborso se non sono soddisfatto?',
  a: 'Ti basterà contattarci entro 14 giorni dall\'acquisto e riceverai il rimborso completo. Nessun rischio, nessuna domanda.'
}];
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <section className="py-8 px-4 sm:px-6 bg-cream" data-id="element-30" data-mp="33memq8e7nwjf">
      <h2 className="text-xl sm:text-3xl font-heading font-extrabold text-center text-petrol leading-tight uppercase mb-5" data-id="element-31" data-mp="33mxw30pspclu">
        Domande Frequenti
      </h2>

      <div className="flex flex-col gap-2 max-w-3xl mx-auto" data-id="element-32" data-mp="2um9ig74bde9h">
        {faqs.map((faq, i) => {
        const isOpen = openIndex === i;
        return <div key={faq.q} className="bg-white border border-gold/30 rounded-lg overflow-hidden" data-id="element-33" data-mp="1n620y96hlcdu" data-mpi={i}>
              <button onClick={() => setOpenIndex(isOpen ? null : i)} aria-expanded={isOpen} aria-controls={`faq-panel-${i}`} className="w-full px-4 py-3 text-left flex justify-between items-center gap-3 hover:bg-cream/60 transition-colors" data-id="element-34" data-mp="3uug5fq636lky">
                <span className="font-heading font-bold text-petrol text-[13px] sm:text-base leading-snug" data-id="element-35" data-mp="cgp4z00xhzh3">
                  {faq.q}
                </span>
                <ChevronDownIcon className={`w-4 h-4 text-sage shrink-0 transition-transform duration-300 ${isOpen ? 'rotate-180' : ''}`} data-id="element-36" data-mp="me3ba6t517vo" />
              </button>
              {isOpen && <p id={`faq-panel-${i}`} className="px-4 pb-3 text-warmgray text-[13px] sm:text-sm leading-relaxed" data-id="element-37" data-mp="vf1gutj85ngd">
                  {faq.a}
                </p>}
            </div>;
      })}
      </div>
    </section>;
}